// extracted by mini-css-extract-plugin
export default {"wrapper":"SaveContact_wrapper__N4E0e","row":"SaveContact_row__5+ylS","item":"SaveContact_item__w-xAR"};